import { render } from "./SectionLatestAuctionsWithCategoryName.vue?vue&type=template&id=5495fde3&scoped=true"
import script from "./SectionLatestAuctionsWithCategoryName.vue?vue&type=script&lang=js"
export * from "./SectionLatestAuctionsWithCategoryName.vue?vue&type=script&lang=js"

import "./SectionLatestAuctionsWithCategoryName.vue?vue&type=style&index=0&id=5495fde3&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5495fde3"]])

export default __exports__